import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, Results } from 'src/app/services/platform-api.service';
import { MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/models/AccountModel';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: []
})
export class UserListComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) userDataTable: DataTableComponent;
  userList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: User) {
    return true;
  }

  selectUser(item: User) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  refresh() {
    this.userDataTable.executeLoadItems();
  }

  loadUsers(filter = new ResultFilter()) {
    this.userDataTable.showProcessing();
    const listObservable = this._platformApi.getUsers(filter);
    listObservable.subscribe(results => {
      this.userList = results;
    })
  }
}
